import {createAction} from "@reduxjs/toolkit";
import {TransportMethod} from "@ots-frontend/ots-data";
import {InsightsDisposalCostType} from "./model/insights-disposal-cost-type";

export const setInsightsFilter = createAction<{ fromDttm: number, toDttm?: number }>("ui/insights/setFilter");
export const setInsightsHaulMethod = createAction<TransportMethod | undefined>("ui/insights/setHaulMethod");
export const setInsightsDisposalCostType = createAction<InsightsDisposalCostType>("ui/insights/setDisposalCostType");
export const setInsightsRateModel = createAction<string | undefined>("ui/insights/setRateModel");
